import { useEffect } from 'react';
import type { GuaArticle } from '@/mocks/gua88-news';
import { TagBadge, TrustBadge } from './articleUi';

export default function ArticleModal({
  article,
  onClose,
}: {
  article: GuaArticle | null;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!article) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [article, onClose]);

  if (!article) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      ></div>
      <div className="relative flex max-h-[86vh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-background-50">
        <div className="relative shrink-0">
          <div className="aspect-[16/7]">
            <img
              src={article.image}
              alt={article.title}
              title={article.title}
              className="h-full w-full object-cover"
            />
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-black/45 text-lg text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        <div className="overflow-y-auto px-5 py-5 md:px-7">
          <div className="flex flex-wrap items-center gap-2">
            <TagBadge tag={article.tag} />
            <TrustBadge trust={article.trust} />
            <span className="text-xs text-foreground-500">{article.time}</span>
          </div>
          <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
            {article.title}
          </h3>
          <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-foreground-700">
            {article.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <p className="mt-5 rounded-md bg-secondary-50 px-3 py-2.5 text-xs leading-relaxed text-secondary-900">
            <i className="ri-information-line mr-1 align-middle"></i>
            本站内容基于公开信息整理转述，事件最终以官方通报与当事人本人说法为准；请理性看待，避免人肉与网络暴力。
          </p>
        </div>
      </div>
    </div>
  );
}